import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Nullable } from '@ps/utils';
import {
  AdvancedTargetingDefinition,
  FeasibilityAudience,
  FeasibilityQuotaGroup,
  Quota,
  Survey,
  SurveyMetadataForm,
} from '@ps/survey-utils';

export const SurveyCreationActions = createActionGroup({
  source: 'Survey Creation',
  events: {
    Init: props<{ surveyId: Nullable<number> }>(),
    'Create Standard Survey': props<{ metadata: SurveyMetadataForm }>(),
    'Update Survey': props<{ metadata: SurveyMetadataForm }>(),
    'Toggle Location Qualification Option': props<{
      qualificationCode: number;
      optionId: string;
    }>(),
    'Clear Location Qualification Selections': emptyProps(),
    // Memory only: applying or removing a definition never calls an endpoint.
    // The accumulated list is persisted by the next metadata save.
    'Apply Advanced Targeting Definition': props<{
      definition: AdvancedTargetingDefinition;
    }>(),
    'Remove Advanced Targeting Definition': props<{
      definition: AdvancedTargetingDefinition;
    }>(),
    // Memory only, same as the definition itself — persisted by the next metadata save.
    'Apply Advanced Targeting Quotas': props<{
      attributeId: string;
      quotas: Quota[];
    }>(),
    // Derived from the loaded survey once its qualifications and the reference
    // list are both in state — see SurveyCreationAudienceEffects.
    'Hydrate Advanced Targeting Definitions': props<{
      definitions: AdvancedTargetingDefinition[];
    }>(),
    Reset: emptyProps(),
  },
});

export const SurveyCreationApiActions = createActionGroup({
  source: 'Survey Creation API',
  events: {
    'Create Standard Survey Success': props<{ survey: Survey }>(),
    'Create Standard Survey Failure': props<{ error: string }>(),
    'Update Standard Survey Success': props<{ survey: Survey }>(),
    'Update Standard Survey Failure': props<{ error: string }>(),
    'Load Survey For Edit Success': props<{ survey: Survey }>(),
    'Load Survey For Edit Failure': props<{ error: string }>(),
  },
});

export const SurveyCreationNavbarActions = createActionGroup({
  source: 'Survey Creation Navbar',
  events: {
    'Compute Score': props<{
      surveyId: number;
      cpi: number;
      ir: number;
      loi: number;
    }>(),
    'Toggle Manual Processing': props<{
      companyId: number;
      enabled: boolean;
    }>(),
    'Recalculate Feasibility': emptyProps(),
  },
});

export const SurveyCreationNavbarApiActions = createActionGroup({
  source: 'Survey Creation Navbar API',
  events: {
    'Compute Score Success': props<{
      score: number;
      scorePercentage: number;
    }>(),
    'Compute Score Failure': props<{ error: string }>(),
    'Recalculate Feasibility Success': props<{
      total: number;
      quotaGroups: FeasibilityQuotaGroup[];
      audience: FeasibilityAudience[];
    }>(),
    'Recalculate Feasibility Failure': props<{ error: string }>(),
  },
});
